<div #container class="grow flex justify-center items-center relative">
  <div class="flex flex-col items-center">
    <div
      class="text-foreground-primary-80"
      [ngClass]="{
        'text-sm': size() === '250',
        'text-xs': size() === '120',
      }"
    >
      {{ label() }}
    </div>
    <div
      class="font-semibold mt-[-5px]"
      [ngClass]="{
        'text-[40px]': size() === '250',
        'text-lg': size() === '120',
      }"
    >
      {{ total() }}
    </div>
  </div>
</div>
